(function () {
  var groupElements = document.querySelectorAll("[data-regime-tab-group]"),
    buttonAttribute = "data-regime-tab-button",
    panelAttribute = "data-regime-tab-panel",
    isActiveClass = "is-active";
  groupElements.forEach((groupElement) => {
    var buttonElements = groupElement.querySelectorAll(`[${buttonAttribute}]`),
      panelElements = groupElement.querySelectorAll(`[${panelAttribute}]`);
    groupElement.addEventListener("click", (event) => {
      if (event.target.matches(`[${buttonAttribute}]`)) {
        var buttonElement = event.target,
          buttonId = buttonElement.getAttribute(buttonAttribute),
          activePanelElements = groupElement.querySelectorAll(
            `[${panelAttribute}='${buttonId}']`
          );
        [...buttonElements, ...panelElements].forEach(
          (buttonOrPanelElement) => {
            buttonOrPanelElement.classList.remove(isActiveClass),
              buttonOrPanelElement.ariaSelected &&
                (buttonOrPanelElement.ariaSelected = "false"),
              buttonOrPanelElement.ariaHidden &&
                (buttonOrPanelElement.ariaHidden = "true");
          }
        ),
          activePanelElements.length &&
            activePanelElements.forEach((activePanelElement) => {
              activePanelElement.classList.add(isActiveClass),
                (activePanelElement.ariaHidden = "false");
            }),
          buttonElement.classList.add(isActiveClass),
          (buttonElement.ariaSelected = "true");
      }
    });
  });
})(),
  (function () {
    var selectElement = document.querySelector("styled-select");
    selectElement &&
      selectElement.addEventListener("change", () => {
        var select = selectElement.querySelector("select");
        location = select.value;
      });
  })(),
  (function () {
    var containerAttribute = "data-regime-product-form-container",
      containerElements = document.querySelectorAll(`[${containerAttribute}]`);
    containerElements.forEach((containerElement) => {
      var containerData = JSON.parse(
          containerElement.getAttribute(containerAttribute)
        ),
        formElement = containerElement.querySelector(
          "[data-regime-product-form]"
        ),
        priceElement = containerElement.querySelector(
          "[data-regime-product-form-price]"
        ),
        imageElement = containerElement.querySelector(
          "[data-regime-product-form-image]"
        ),
        quickviewAttribute = "data-regime-product-form-quickview",
        quickviewProductAttribute = "data-product",
        quickviewElement = containerElement.querySelector(
          `[${quickviewAttribute}]`
        );
      let reChargeWidget = !1;
      window.addEventListener("ReChargeWidget-loaded", () => {
        const reChargeWidgetConfig = {
          productId: containerData.product.id,
          injectionParent: `[data-regime-product-form-recharge][data-form-id="${containerData.formId}"]`,
          selectors: { variant: [".regime-product-card__select"] },
        };
        reChargeWidget =
          window.ReChargeWidget.createWidget(reChargeWidgetConfig);
        let count = 0;
        const checkWidgetRendered = setInterval(() => {
          if ((count++, reChargeWidget.isRendered)) {
            clearInterval(checkWidgetRendered),
              containerElement
                .querySelector("[data-regime-product-form-price]")
                .classList.add("hide");
            const rechargeContainer = document.querySelector(
              `[data-form-id=${containerData.formId}]`
            );
            insertRechargeCompareSpan(rechargeContainer, "onetime"),
              insertRechargeCompareSpan(rechargeContainer, "subsave");
            const variantId = rechargeContainer
              .closest("form")
              .querySelector("select").value;
            sitewide &&
              sitewide.updateRegimeSubscriptionPricing(
                variantId,
                rechargeContainer
              ),
              rechargeContainer
                .querySelectorAll(".rc-option")
                .forEach((option) => {
                  option.addEventListener(
                    "click",
                    (e) =>
                      e.target.value &&
                      updateAtcPriceBoxFromSubs(
                        e,
                        rechargeContainer.closest("form")
                      )
                  );
                });
          }
          count === 40 &&
            (clearInterval(checkWidgetRendered),
            console.error("The recharge widget did not render in time"));
        }, 100);
      }),
        formElement.addEventListener("change", () => {
          
          formElement.querySelector(
            ".rc_widget__option--subsave.rc-option--active"
          )
            ? formElement.setAttribute(
                "data-selling-plan",
                formElement.querySelector(".rc-selling-plans__dropdown").value
              )
            : formElement.removeAttribute("data-selling-plan");
          var variant = containerData.product.variants.find(
            (variant2) => variant2.id == formElement.id.value
          );
          if (variant) {
            
            if (
              (formElement
                .querySelector(".regime-product-card__submit")
                .setAttribute("data-variant-id", variant.id),
              priceElement.querySelector("s")?.remove(),
              variant.compare_at_price)
            ) {
              console.log("com");
              const prePriceElement = document.createElement("s");
              (prePriceElement.className = "price-v2-pdp price-v2__pre-pdp"),
                prePriceElement.setAttribute("aria-hidden", "true"),
                prePriceElement.setAttribute(
                  "compare-at",
                  variant.compare_at_price
                ),
                (prePriceElement.textContent = formatPrice(
                  containerData.currencySymbol,
                  variant.compare_at_price
                )),
                priceElement.insertBefore(
                  prePriceElement,
                  priceElement.firstChild
                );
            }
            if (
              ((priceElement.querySelector("span").textContent = formatPrice(
                containerData.currencySymbol,
                variant.price
              )),
              reChargeWidget &&
                ((reChargeWidget.state.selectedVariantId = variant.id),
                reChargeWidget.store.dispatch(
                  "setSelectedVariantId",
                  reChargeWidget.state.selectedVariantId
                ),
                reChargeWidget.syncVariant(),
                (formElement.querySelector(
                  "s.compare-at--onetime"
                ).textContent = variant.compare_at_price
                  ? formatPrice(
                      containerData.currencySymbol,
                      variant.compare_at_price
                    )
                  : "")),
              sitewide)
            ) {
              const priceV2Span = formElement.querySelector(
                "span.price-v2__actual-pdp"
              );
              console.log("helo",priceV2Span);
              updateVariantData(variant.id, priceV2Span),
                sitewide.updateRegimePriceV2(String(variant.id), priceV2Span),
                sitewide.updateRegimeSubscriptionPricing(
                  String(variant.id),
                  formElement
                );
            }
            if (
              (imageElement &&
                variant.featured_image?.src &&
                (imageElement.src = imageElement.srcset =
                  variant.featured_image.src),
              quickviewElement)
            ) {
              var quickviewValue = `${
                quickviewElement
                  .getAttribute(quickviewProductAttribute)
                  .split("?")[0]
              }?variant=${variant.id}`;
              quickviewElement.setAttribute(
                quickviewProductAttribute,
                quickviewValue
              );
            }
          }
        });
    });
    function formatPrice(currencySymbol, priceData) {
      if (!priceData) return null;
      let priceFloat = priceData / 100;
      // return Number.isInteger(priceFloat)
      //   ? `${currencySymbol}${priceFloat}`
      //   : Shopify.formatMoney(priceData, `${currencySymbol}`);
      return Shopify.formatMoney(priceData, `${currencySymbol}`);
    }
    function updateVariantData(variantId, priceV2Span) {
      const classToRemove = [...priceV2Span.classList].find(
        (className) =>
          className.startsWith("price-v2__") &&
          /^\d+$/.test(className.slice(10))
      );
      classToRemove && priceV2Span.classList.remove(classToRemove),
        priceV2Span.classList.add(`price-v2__${variantId}`);
    }
  })();
class regimeToolbar extends HTMLElement {
  constructor() {
    super(),
      (this.regimeTabs = document.querySelector("[data-regime-tab-group]")),
      (this.cartButton = document.querySelector(".js-cart-toggle")),
      (this.submitButton = this.querySelector("[js-submit]")),
      this.submitButton.addEventListener("click", () => this.handleSubmit());
  }
  async handleSubmit() {
    const submitButtons = [
      ...this.regimeTabs.querySelectorAll(".regime-product-cards.is-active"),
    ].flatMap((tabGroup) => [
      ...tabGroup.querySelectorAll(
        ".regime-product-cards.is-active [data-regime-product-form-submit]"
      ),
    ]);
    this.submitButton.classList.add("btn--loading");
    let formData = { items: [] };
    for (const button of submitButtons) {
      let sellingPlan;
      button.form.getAttribute("data-selling-plan")
        ? (sellingPlan = button.form.getAttribute("data-selling-plan"))
        : (sellingPlan = "");
      let newItem = {
        id: button.getAttribute("data-variant-id"),
        quantity: 1,
        selling_plan: sellingPlan,
      };
      formData.items.push(newItem);
    }
   
    (await new GlobalCart())
      .addToCart(formData, !1)
      .then((response) => {
        window.globalSideBarUI__cart.open(),
          this.submitButton.classList.remove("btn--loading");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}
window.customElements.define("regime-toolbar", regimeToolbar),
  window.addEventListener("load", () => {
    setTimeout(() => {
      document.querySelectorAll(".rc-radio__label").forEach((label) => {
        label.addEventListener("click", (event) => {
          event.preventDefault(),
            event.currentTarget.parentNode.querySelector("input").click();
        });
      });
    }, 1500);
  });
class swymButton extends HTMLElement {
  constructor() {
    super();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.attributeName === "class" &&
          (this.classList.toggle(
            "swym-added-on-load",
            this.classList.contains("swym-added")
          ),
          this.classList.contains("swym-loaded") && observer.disconnect());
      });
    });
    observer.observe(this, { attributes: !0 }),
      this.addEventListener("click", this.clickHandler.bind(this));
  }
  clickHandler() {
    const classCondition =
      this.classList.contains("swym-adding") &&
      !this.classList.contains("swym-removed");
    this.classList.toggle("swym-removed", classCondition),
      this.classList.remove("swym-added-on-load");
  }
}
window.customElements.define("swym-button", swymButton);
class StyledSelect extends HTMLElement {
  constructor() {
    super(),
      (this.select = this.querySelector("select")),
      (this.select.style.display = "none"),
      this.renderDropdown();
  }
  renderDropdown() {
    (this.dropdown = document.createElement("div")),
      this.dropdown.classList.add("styled-select-menu"),
      this.dropdown.setAttribute("aria-labelledby", "styled-dropdown-button");
    const contentContainer = document.createElement("div");
    contentContainer.classList.add("styled-select-menu__content"),
      [...this.select.children].some((child) => child.tagName === "OPTGROUP")
        ? [...this.select.children].forEach((option) => {
            if (option.tagName === "OPTGROUP") {
              const group = document.createElement("h3");
              (group.textContent = option.label),
                contentContainer.appendChild(group),
                Array.from(option.children).forEach((opt) => {
                  const button = this.createButton(opt);
                  contentContainer.appendChild(button);
                });
            }
          })
        : [...this.select.children].forEach((option) => {
            if (option.tagName === "OPTION") {
              const button = this.createButton(option);
              contentContainer.appendChild(button);
            }
          }),
      this.dropdown.appendChild(contentContainer),
      (this.dropdownButton = document.createElement("button")),
      this.dropdownButton.classList.add("styled-dropdown__toggle"),
      (this.dropdownButton.id = "styled-dropdown-button"),
      (this.dropdownButton.ariaHasPopup = "true"),
      (this.dropdownButton.ariaExpanded = "false"),
      (this.selectedOption =
        this.select.options[this.select.selectedIndex].textContent),
      (this.dropdownButton.textContent = this.selectedOption.trim()),
      this.appendChild(this.dropdownButton),
      this.dropdownButton.addEventListener("click", () =>
        this.toggleDropdown()
      ),
      this.appendChild(this.dropdown),
      document.addEventListener("click", (event) => {
        this.dropdownButton.contains(event.target) ||
          (this.dropdown.classList.remove("open"),
          (this.dropdownButton.ariaExpanded = "false"));
      });
  }
  createButton(option) {
    const button = document.createElement("button");
    return (
      (button.textContent = option.textContent),
      (button.value = option.value),
      option.selected && button.classList.add("selected"),
      button.addEventListener("click", () => {
        (this.select.value = option.value),
          this.dispatchEvent(new Event("change")),
          (this.selectedOption = option.textContent),
          (this.dropdownButton.textContent = this.selectedOption.trim()),
          this.toggleDropdown();
      }),
      button
    );
  }
  toggleDropdown() {
    this.dropdown.classList.toggle("open"),
      this.dropdown.classList.contains("open") &&
        this.dropdown.querySelector("button") &&
        this.dropdown.querySelector("button").focus(),
      this.dropdownButton.ariaExpanded == "true"
        ? (this.dropdownButton.ariaExpanded = "false")
        : (this.dropdownButton.ariaExpanded = "true");
  }
}
function insertRechargeCompareSpan(container, classSuffix) {
  let priceSpan = container.querySelector(`.rc_widget__price--${classSuffix}`);
  priceSpan.style = "margin-left: 10px";
  const compareSpan = document.createElement("s");
  (compareSpan.className = `rc_widget__price compare-at--${classSuffix} f-w400`),
    priceSpan.parentNode.insertBefore(compareSpan, priceSpan);
}
function updateAtcPriceBoxFromSubs(event, src = document) {
  if (event.target.tagName !== "INPUT") return;
  const subsType = event.target.value,
    pricePre = event.target
      .closest(".rc-widget")
      .querySelector(`s.compare-at--${subsType}`).textContent,
    priceActual = event.target
      .closest(".rc-widget")
      .querySelector(`span.rc_widget__price--${subsType}`).textContent,
    priceBox = src.querySelector(".regime-product-card__submit");
  setTimeout(() => {
    priceBox.querySelector("s.price-v2__pre-pdp") &&
      (priceBox.querySelector("s.price-v2__pre-pdp").textContent = pricePre),
      (priceBox.querySelector("span.price-v2__actual-pdp").textContent =
        priceActual);
  }, 0);
}
window.customElements.define("styled-select", StyledSelect);
